import { Component } from '@angular/core';
import { NavigationServiceOpen } from 'app/shared/navigation-open/navigation.service';

@Component({
    selector: 'app-restricted-access',
    templateUrl: 'restricted-access.component.html',
    styleUrls: ['restricted-access.component.scss']
})
export class RestrictedAccessComponent {
    title = 'app';
    constructor(private navigationServiceOpen: NavigationServiceOpen) {}
    showHamburgerMenu(): boolean {
        return this.navigationServiceOpen.showHamburgerMenu;
    }
}
